import { InjectionToken } from '@angular/core';

/**
 * An app's own device-id service, bound through `provideRmaPostHog` for the same reason the platform
 * service is: this library cannot import one app's copy without tying every other app to that scope.
 */
export interface PostHogDeviceId {
  getDeviceId(): string;
}

export const POSTHOG_DEVICE_ID = new InjectionToken<PostHogDeviceId>('POSTHOG_DEVICE_ID');
